import {WithholdingFromLoanOrPartialWithdrawals as WitholdingFromLoanLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';

type WitholdingFromLoanLetterProps = {
  witholdingFromLoanLetter: WitholdingFromLoanLetter;
};

const WitholdingFromLoan = (props: WitholdingFromLoanLetterProps) => {
  return (
    <>
      <CardField name={'Insured Name'} value={props.witholdingFromLoanLetter.insuredName} />
      <CardField name={'Owner Name'} value={props.witholdingFromLoanLetter.ownerName} />
      <CardField name={'Owner Address'} value={props.witholdingFromLoanLetter.ownerAddress!.fullAddress} />
      <CardField name={'Policy Number'} value={props.witholdingFromLoanLetter.policyNumber} />
      <CardField name={'Date'} value={toFormattedDateAsUTC(props.witholdingFromLoanLetter.date)} />
      <CardField name={'Agent Number'} value={props.witholdingFromLoanLetter.agentNumber} />
      <CardField name={'Witholding Amount'} value={toMoneyValue(props.witholdingFromLoanLetter.withheldAmount)} />
    </>
  );
};

export default WitholdingFromLoan;
